
import { numberToHumanSize } from 'bits/numbers_helper'
import { Component, Prop, Vue } from 'bits/vue'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzLoadingSpinner from 'library/v4/components/OzLoadingSpinner.vue'
import OzMembershipTierGrid from 'library/v4/components/OzMembershipTierGrid.vue'

export enum Type {
  Library,
  Personal,
}

export enum Variant {
  UnderPadletQuota,
  AtPadletQuota,
  OverPadletQuota,
  FileSize,
  SignUp,
  Continue,
}

@Component({ components: { OzBox, OzContainedButton, OzIcon, OzLoadingSpinner, OzMembershipTierGrid } })
export default class NeonMembershipTier extends Vue {
  /**
   * Number of walls used by the user/library. Used for quota variants.
   */
  @Prop({ required: false }) wallsUsed!: number

  /**
   * File size to display if the variant is "FileSize".
   */
  @Prop({ required: false }) fileSize!: number

  /**
   * Defines which variant should be displayed.
   */
  @Prop({ required: true }) variant!: Variant

  /**
   * Determines whether the OzMembershipTierGrid component should be expanded or not.
   */
  @Prop({ required: true }) isExpanded!: boolean

  /**
   * Determines whether the plan information is being loaded or not.
   */
  @Prop({ required: true }) isLoadingPlanInformation!: boolean

  /**
   * Determines whether to show the checkmark next to the tier name or not.
   */
  @Prop({ default: false }) xChecked!: boolean

  /**
   * The maximum amount of walls allowed in this Tier.
   */
  @Prop({ required: true }) advertisedWallsQuota!: number

  /**
   * The maximum upload file size allowed in this Tier.
   */
  @Prop({ required: true }) advertisedFileSizeQuota!: string

  /**
   * Whether Advertised Quotas have been fetched.
   */
  @Prop({ required: true }) isLoadingAdvertisedQuotas!: boolean

  /**
   * Whether the user is logged in or not. Used by the "SignUp" variant.
   */
  @Prop({ required: false }) isUserLoggedIn?: boolean

  /**
   * Determines whether the tier is a "Personal" tier or a "Library" tier.
   */
  @Prop({ default: Type.Personal }) type!: Type

  /**
   * The URL to redirect in the "Continue" variant.
   */
  @Prop({ required: false }) continueUrl!: string

  numberToHumanSize = numberToHumanSize
  OzContainedButtonSizePreset = OzContainedButtonSizePreset
  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  Type = Type
  Variant = Variant

  get isPadletQuotaOrFileSizeVariant(): boolean {
    return (
      this.variant === Variant.UnderPadletQuota ||
      this.variant === Variant.AtPadletQuota ||
      this.variant === Variant.OverPadletQuota ||
      this.variant === Variant.FileSize
    )
  }

  get colorScheme(): OzBoxColors | null {
    if (this.isPadletQuotaOrFileSizeVariant) return OzBoxColors.Secondary
    if (this.variant === Variant.Continue) return OzBoxColors.Pink
    return null
  }
}
